import { EventEmitter } from 'events';
import AdminConstants from '../constants/AdminConstants';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import assign from 'object-assign';
import { findIndex } from 'lodash/array';
import _ from 'underscore';
import ToastStore from 'stores/ToastStore';
import i18next from 'i18next';
const ActionTypes = AdminConstants.ActionTypes;
var tariffs = [];
var tariff = {};
var usage = {};
var TariffsStore = assign({}, EventEmitter.prototype, {
    defaults: {
        status: false,
        error: false
    },
    reset() {
        this.status = false;
        this.error = false;
    },
    getStatus() {
        return this.status;
    },
    getError() {
        return this.error;
    },
    getTariffIndex(tariff) {
        return findIndex(tariffs, {
            _id: tariff._id
        });
    },
    getTariffs() {
        return tariffs || [];
    },
    getTariff() {
        return tariff || {};
    },
    getUsage() {
        return usage || {};
    },
    receiveTariffs(data) {
        tariffs = data;
        this.status = 'success';
    },
    receiveTariff(data) {
        tariff = data;
        this.status = 'success';
    },
    receiveAddTariffSuccess(data) {
        tariff = data.tariff;
        if (tariff)
            tariffs.push(tariff);
        this.status = 'success';
        toast(i18next.t('NEW_TARIFF_ADDED'), 'success');
    },
    receiveUpdateTariffSuccess(data) {
        tariff = data;
        if (tariff) {
            var idx = this.getTariffIndex(tariff);
            if (idx < tariffs.length) {
                tariffs[idx] = tariff;
            }
        }
        this.status = 'success';
        toast(i18next.t('TARIFF_UPDATED'), 'success');
    },
    receiveUpdateTariffFail(data) {
        this.status = 'fail';
        this.error = data.entity;
        toast(i18next.t('TARIFF_UPDATE_FAILED'), 'error');
    },
    receiveRemoveTariffSuccess(data) {
        toast(i18next.t('TARIFF_REMOVED'), 'success');
        tariff = data;
        if (tariff) {
            tariffs = _.reject(tariffs, function (item) {
                return item._id === tariff._id;
            });
        }
        this.status = 'success';
    },
    receiveRemoveTariffFail(data) {
        this.status = 'fail';
        this.error = data.entity;
        toast(i18next.t('TARIFF_REMOVE_FAILED'), 'error');
    },
    receiveGetTariffUsage(data) {
        this.status = 'success';
        usage = data.entity.tariffs;
    },
    emitChange() {
        this.emit('change');
    },
    addChangeListener(callback) {
        this.on('change', callback);
    },
    removeChangeListener(callback) {
        this.removeListener('change', callback);
    }
});
TariffsStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    var action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_TARIFFS:
            TariffsStore.receiveTariffs(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.RECEIVE_TARIFF:
            TariffsStore.receiveTariff(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.UPDATE_TARIFF_SUCCESS:
            TariffsStore.receiveUpdateTariffSuccess(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.UPDATE_TARIFF_FAIL:
            TariffsStore.receiveUpdateTariffFail(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.REMOVE_TARIFF_SUCCESS:
            TariffsStore.receiveRemoveTariffSuccess(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.REMOVE_TARIFF_FAIL:
            TariffsStore.receiveRemoveTariffFail(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.ADD_TARIFF_SUCCESS:
            TariffsStore.receiveAddTariffSuccess(action.data);
            TariffsStore.emitChange();
            break;
        case ActionTypes.GET_TARIFFS_USAGE:
            TariffsStore.receiveGetTariffUsage(action.data);
            TariffsStore.emitChange();
            break;
    }
});
// Shorcut to display messages to the user
function toast(message, level) {
    if (!level)
        level = "error";
    ToastStore.getNotifications().push({
        title: message,
        body: '',
        level: level
    });
    ToastStore.emitChange();
}
export default TariffsStore;
